<div 
    class="button-icon" 
    [ngClass]="'button-icon--' + iconPlacement">
    <div class="button-icon__icon">
        <app-icon [icon]="icon"></app-icon>
        <app-icon class="button-icon__arrow" icon="angle-down" size="sm" *ngIf="arrow === 'down'"></app-icon>
        <app-icon class="button-icon__arrow" icon="angle-up" size="sm" *ngIf="arrow === 'up'"></app-icon>
    </div>
    
    <div
        class="button-icon__label"
        [ngClass]="{
            'button-icon__label--light': color === 'light',
            'button-icon__label--dark': color === 'dark',
            'button-icon__label--small': labelSize === 'small',
            'button-icon__label--medium': labelSize === 'medium',
            'button-icon__label--large': labelSize === 'large'
        }">
        {{ label }}
    </div>
</div>